export default "__VITE_ASSET__$BzXBcGJ__"